import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Kanyakumari extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Vivekananda Rock Memorial",
        image: "/assets/img/vivekananda-rock.jpeg",
        description: "A sacred monument built on a rock surrounded by the sea. It stands as a symbol of peace and meditation, where Swami Vivekananda meditated in 1892.",
        highlight: "Spiritual Landmark",
        bestTime: "Morning",
        duration: "1-2 Hours",
        tip: "Take a ferry from the mainland"
      },
      {
        name: "Thiruvalluvar Statue",
        image: "/assets/img/thiruvalluvar-statue.jpeg",
        description: "A 133-feet tall stone statue of the famous Tamil poet and philosopher Thiruvalluvar. It stands adjacent to the Vivekananda Rock Memorial.",
        highlight: "Iconic Monument",
        bestTime: "Sunrise",
        duration: "1 Hour",
        tip: "Best viewed during sunrise"
      },
      {
        name: "Kanyakumari Beach",
        image: "/assets/img/kanyakumari-beach.jpg",
        description: "The southernmost tip of mainland India where the Arabian Sea, Bay of Bengal, and Indian Ocean meet. Famous for spectacular sunrise and sunset views.",
        highlight: "Three Seas Meeting Point",
        bestTime: "Sunrise & Sunset",
        duration: "2-3 Hours",
        tip: "Don't miss the sunset"
      },
      {
        name: "Bhagavathy Amman Temple",
        image: "/assets/img/bhagavathy-temple.jpg",
        description: "An ancient temple dedicated to Goddess Kanyakumari, believed to be over 3000 years old. The temple holds great spiritual significance.",
        highlight: "Ancient Temple",
        bestTime: "Morning/Evening",
        duration: "1 Hour",
        tip: "Traditional dress recommended"
      },
      {
        name: "Gandhi Memorial",
        image: "/assets/img/gandhi-memorial.jpg",
        description: "Built on the spot where Mahatma Gandhi's ashes were kept before immersion. The architecture allows sunlight to fall on the spot of urn on his birthday.",
        highlight: "Historic Monument",
        bestTime: "All Day",
        duration: "45 mins",
        tip: "Visit during morning hours"
      },
      {
        name: "Sunset View Point",
        image: "/assets/img/sunset-point.jpg",
        description: "The perfect spot to witness the breathtaking sunset where you can see the sun setting into the Arabian Sea.",
        highlight: "Spectacular Sunset",
        bestTime: "Evening",
        duration: "1 Hour",
        tip: "Arrive 30 mins before sunset"
      },
      {
        name: "Tsunami Memorial",
        image: "/assets/img/tsunami-memorial.jpg",
        description: "A memorial dedicated to the victims of the 2004 Indian Ocean tsunami. It stands as a reminder of nature's power and human resilience.",
        highlight: "Historical Significance",
        bestTime: "All Day",
        duration: "30 mins",
        tip: "Read the stories of survivors"
      },
      {
        name: "Mathur Aqueduct",
        image: "/assets/img/mathur-aqueduct.jpg",
        description: "One of the longest and highest aqueducts in South India, offering stunning views of the surrounding landscape.",
        highlight: "Engineering Marvel",
        bestTime: "Morning",
        duration: "1-2 Hours",
        tip: "Great for photography"
      }
    ];

    const experiences = [
      {
        title: "Sunrise Viewing",
        description: "Witness the spectacular sunrise where the sun rises from the ocean",
        icon: "fas fa-sun"
      },
      {
        title: "Ferry Ride",
        description: "Take a boat ride to the rock memorials in the sea",
        icon: "fas fa-ship"
      },
      {
        title: "Beach Walk",
        description: "Walk along the southernmost beach of mainland India",
        icon: "fas fa-umbrella-beach"
      },
      {
        title: "Spiritual Tour",
        description: "Explore ancient temples and spiritual landmarks",
        icon: "fas fa-pray"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Kanyakumari District, Tamil Nadu", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "October to March", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Trivandrum International Airport (87 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Kanyakumari Railway Station (1 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Sunrise, Sunset, Three Seas Meeting", icon: "fas fa-water" },
      { label: "Language", value: "Tamil, English, Malayalam", icon: "fas fa-language" }
    ];

    const festivals = [
      {
        name: "Cape Festival",
        month: "October",
        description: "Cultural festival celebrating the heritage of Kanyakumari with music, dance, and food"
      },
      {
        name: "Navaratri",
        month: "September-October",
        description: "Grand celebrations at Bhagavathy Amman Temple with special poojas and decorations"
      },
      {
        name: "Vaikasi Visakam",
        month: "May-June",
        description: "Annual festival at the temple attracting thousands of devotees"
      }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/kanyakumari-hero.png" alt="Kanyakumari Sunrise" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Land's End of India</span>
            </div>
            <h1 className="dest-hero-title">Kanyakumari</h1>
            <p className="dest-hero-subtitle">
              Where the oceans meet and the sun rises from the sea
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Kanyakumari District, Tamil Nadu, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Kanyakumari</h2>
                <p className="dest-intro-description">
                  Kanyakumari, formerly known as Cape Comorin, is the southernmost tip of mainland India. 
                  This coastal town is where the Arabian Sea, Bay of Bengal, and Indian Ocean converge, 
                  creating a spectacular natural phenomenon.
                </p>
                <p className="dest-intro-description">
                  Famous for its stunning sunrise and sunset views, Kanyakumari holds immense spiritual 
                  and cultural significance. The town is named after the goddess Kanyakumari, whose temple 
                  stands at the edge of the shore. The Vivekananda Rock Memorial and Thiruvalluvar Statue 
                  are iconic landmarks that attract visitors from around the world.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? Kanyakumari is the only place in India where you can witness both sunrise and sunset over the ocean on the same day.</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Experiences in Kanyakumari</h2>
            <p className="dest-section-subtitle">
              Unique ways to explore the southern tip of India
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="exp-description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="dest-attractions-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Top Attractions in Kanyakumari</h2>
            <p className="dest-section-subtitle">
              Discover the iconic landmarks and scenic spots
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="dest-time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        <div className="travel-tip">
                          <i className="fas fa-lightbulb"></i>
                          <span>{attraction.tip}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Sunrise & Sunset Section */}
        <div className="sunrise-section">
          <div className="sunrise-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="sunrise-content">
                <div className="sunrise-badge">Natural Wonder</div>
                <h2 className="sunrise-title">The Spectacular Sunrise & Sunset</h2>
                <p className="sunrise-description">
                  Kanyakumari offers a unique phenomenon where you can witness both sunrise and sunset 
                  over the ocean. The sun rises from the Bay of Bengal and sets into the Arabian Sea, 
                  creating breathtaking views that attract photographers and nature lovers from across 
                  the globe.
                </p>
                <p className="sunrise-description">
                  The best time to witness this spectacle is during the months of October to March 
                  when the skies are clear. The sunrise at the Vivekananda Rock Memorial is particularly 
                  mesmerizing as the first rays of sun hit the monument.
                </p>
                <div className="sunrise-tips">
                  <div className="tip">
                    <i className="fas fa-clock"></i>
                    <span>Best sunrise time: 6:00 AM - 6:30 AM</span>
                  </div>
                  <div className="tip">
                    <i className="fas fa-clock"></i>
                    <span>Best sunset time: 5:30 PM - 6:00 PM</span>
                  </div>
                  <div className="tip">
                    <i className="fas fa-camera"></i>
                    <span>Perfect for photography enthusiasts</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Rock Memorial Section */}
        <div className="rock-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="rock-content">
                <div className="rock-badge">Spiritual Heritage</div>
                <h2 className="rock-title">Vivekananda Rock Memorial</h2>
                <p className="rock-description">
                  The Vivekananda Rock Memorial stands on a rock surrounded by the sea, where Swami 
                  Vivekananda meditated in 1892 before his journey to Chicago. The memorial was built 
                  in 1970 and has since become one of India's most important spiritual landmarks.
                </p>
                <p className="rock-description">
                  The rock is accessible by ferry and houses two main structures: the Vivekananda 
                  Mandapam and the Shripada Mandapam, where a footprint believed to be of Goddess 
                  Kanyakumari is preserved. The meditation hall offers a peaceful environment for 
                  contemplation.
                </p>
                <div className="rock-info">
                  <div className="info-item">
                    <i className="fas fa-ship"></i>
                    <span>Ferry available every 15-20 minutes</span>
                  </div>
                  <div className="info-item">
                    <i className="fas fa-clock"></i>
                    <span>Open: 8:00 AM - 4:00 PM</span>
                  </div>
                  <div className="info-item">
                    <i className="fas fa-ticket-alt"></i>
                    <span>Entry fee: ₹50 (includes ferry)</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Thiruvalluvar Statue Section */}
        <div className="statue-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="statue-content">
                <div className="statue-badge">Iconic Monument</div>
                <h2 className="statue-title">Thiruvalluvar Statue</h2>
                <p className="statue-description">
                  Standing at an impressive height of 133 feet, the Thiruvalluvar Statue is a tribute 
                  to the famous Tamil poet and philosopher who wrote the Thirukkural. The statue is 
                  situated on a small island rock adjacent to the Vivekananda Rock Memorial.
                </p>
                <p className="statue-description">
                  The 133 feet height represents the 133 chapters of the Thirukkural. The statue was 
                  unveiled in 2000 and has become an iconic landmark of Kanyakumari. Visitors can climb 
                  up to the feet of the statue for a panoramic view of the surrounding ocean.
                </p>
                <div className="statue-stats">
                  <div className="stat">
                    <span className="number">133</span>
                    <span className="label">Feet Tall</span>
                  </div>
                  <div className="stat">
                    <span className="number">133</span>
                    <span className="label">Chapters</span>
                  </div>
                  <div className="stat">
                    <span className="number">7</span>
                    <span className="label">Tons Weight</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Festivals Section */}
        <div className="festivals-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Festivals & Events</h2>
              <p className="dest-section-subtitle">Celebrate the vibrant culture of Kanyakumari</p>
            </div>
            <Row className="festivals-grid">
              {festivals.map((festival, index) => (
                <Col xs={12} sm={6} md={4} key={index} className="festival-col">
                  <div className="festival-card">
                    <div className="festival-month">{festival.month}</div>
                    <h3 className="festival-name">{festival.name}</h3>
                    <p className="festival-description">{festival.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Kanyakumari</h2>
              <p className="dest-section-subtitle">Make the most of your visit to the southern tip</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <h4>Best Time to Visit</h4>
                  <p>October to March offers pleasant weather and clear skies for sunrise and sunset views</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-tshirt"></i>
                  </div>
                  <h4>What to Wear</h4>
                  <p>Light cotton clothes, comfortable footwear. Carry a hat and sunglasses for sun protection</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-ship"></i>
                  </div>
                  <h4>Ferry Tips</h4>
                  <p>Take early morning ferry to avoid crowds. Last ferry is at 4:00 PM</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-utensils"></i>
                  </div>
                  <h4>Must Try</h4>
                  <p>Fresh seafood, local Tamil cuisine, and coconut-based dishes</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Experience the Magic of Kanyakumari</h3>
            <p>Let us help you plan your journey to the southern tip of India</p>
            <Link to="/contact" className="dest-cta-button">
              Plan Your Trip
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}